import { FC, memo } from 'react'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import { CompanyPayment } from '@leadgen/models/client'
import { dateFormatter } from '../../../../../formatters/dateFormatter'
import { currencyFormatter } from '../../../../../formatters/currencyFormatter'
import Box from '@mui/material/Box'
import { useDownloadFile } from '../../../../../hooks/shared/useDownloadFile'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import config from '../../../../../config'
import authSelectors from '../../../../../redux/modules/auth/selectors'
import { useSelector } from '../../../../../redux/hooks'

const CompanyPaymentsTableRow: FC<{
  companyPayment: CompanyPayment
}> = ({ companyPayment }) => {
  const companyId = useSelector(authSelectors.getCompanyId)
  const { downloadFile, loading } = useDownloadFile({
    url: `${config.bucketBaseUrl}${encodeURIComponent(`payments/${companyId}/${companyPayment.id}.pdf`)}?alt=media`,
    fileName: `${companyPayment.stripeChargeId}.pdf`,
  })
  return (
    <TableRow key={companyPayment.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell component="th" scope="row">
        <Box
          style={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            WebkitLineClamp: 2, // Limits the text to 2 lines
            textOverflow: 'ellipsis',
          }}
        >
          {dateFormatter.formatDisplayDate(companyPayment.datePaid)}
        </Box>
      </TableCell>
      <TableCell align="left">{companyPayment.creditsPurchased}</TableCell>
      <TableCell align="right">
        {currencyFormatter.formatPenceToGBPAmountString(companyPayment.amountPaid)}
        {'  '}
        <Tooltip title="Export">
          <IconButton onClick={downloadFile} disabled={loading}>
            <DownloadForOfflineIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}

export default memo(CompanyPaymentsTableRow)
